/**
 * Рация: вход в голос сессии и выход из него.
 *
 * Нарисована руками, хотя правило проекта велит брать общие значки из lucide: рации там нет.
 * Ближайшее по имени - `radio-receiver` - это стереоприёмник, лежачая коробка на ножках, и
 * читается он как колонка, а не как «взять рацию и выйти на связь».
 *
 * Зачем вообще менять: до 26.09.2026 на входе в голос стояла телефонная трубка, и она обещала
 * не то - звонок кому-то, а не разговор с командой, которая уже собралась. Трубка осталась там,
 * где она правда про звонок: личные звонки 1:1, карточка пропущенного, полка «звал в голос».
 * Разделение простое и его видно с первого взгляда: трубка - позвонить человеку, рация - зайти
 * к команде.
 *
 * Пара обязательна: у входа должен быть выход, нарисованный тем же предметом. Раньше выход из
 * голоса рисовался двумя разными значками - перечёркнутой трубкой, пока соединение собиралось,
 * и дверью со стрелкой, когда собралось, - то есть одно действие меняло вид на полпути.
 *
 * Сетка и толщина линий - как у lucide (24×24, stroke 2, currentColor): значок стоит в одном
 * ряду с ними, и любое расхождение видно сразу.
 */
export const WalkieIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    /* Метка для тестов: ею держится правило «одно действие – один значок». */
    data-icon="walkie"
    {...props}
  >
    <rect x="6" y="8" width="11" height="13" rx="2" />
    <path d="M13.5 8V4" />
    <path d="M9.5 12h4" />
    <path d="M9.5 16h2" />
    <path d="M17.5 4.5a4.5 4.5 0 0 1 3 3" />
  </svg>
);

/** Та же рация с косой чертой: выйти из голоса. Дуга сигнала снята - она спорила бы с чертой. */
export const WalkieOffIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    data-icon="walkie-off"
    {...props}
  >
    {/*
      Тело то же, что у целой рации, но с разрывом там, где проходит черта: у «off»-вариантов
      lucide штрих не пересекается с ней, иначе на 16 пикселях получается узел. Решётку в
      перечёркнутом варианте не рисуем вовсе - она попадает ровно под черту.
    */}
    <path d="M10 8h5a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-8" />
    <path d="M13.5 8V4" />
    <path d="m2 2 20 20" />
  </svg>
);
